import { defineStore } from "pinia";
import { instance } from "./index";

const store = defineStore({
  id: "video",
  state: () => ({
    videoEnded: null as boolean | null,
    attention: false as boolean,
    player: null as any,
  }),
  getters: {
    getVideoEnded: (state) => state.videoEnded,
    getAttention: (state) => state.attention,
    getPlayer: (state) => {
      if (state.player !== null) return state.player;
    },
  },
  actions: {
    setVideoEnded(value: boolean) {
      this.videoEnded = value;
    },
    setAttention(value: boolean) {
      this.attention = value;
    },
    setPlayer(value: any) {
      this.player = value;
    },
  },
});

export const useVideoStore = store(instance);
